import * as React from 'react';
import { IToast } from 'store/ui/toasts/toastsTypes';
import Toast from 'components/toasts/Toast';
import 'components/toasts/ToastAnimations.css';
import { ApplicationState } from 'store/rootReducer';
import { hideToast } from 'store/ui/toasts/toastsActions';
import { connect } from 'react-redux';

type MapToStateProps = ReturnType<typeof mapStateToProps>;
type AllProps = MapToStateProps & DispatchProps;

const mapStateToProps = (state: ApplicationState) => ({
  toasts: state.ui.toasts,
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  hideToast: toast => dispatch(hideToast(toast)),
});

export interface DispatchProps {
  hideToast: (toast: IToast) => any;
}

class Toasts extends React.Component<AllProps> {
  render() {
    return (
      <div className="toasts toasts-top">
        {this.props.toasts.map((toast: IToast) => (
          <Toast key={toast.timestamp} toast={toast} hideToast={() => hideToast(toast)} />
        ))}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Toasts);
